import reactComponentLoader from 'scripts/react-component-loader'

import ContentList from '../ContentList'

reactComponentLoader(ContentList, '[data-content-list]')
